  import { simpleLookupConfig } from "../../../../records/lookup/config/simpleLookupConfig";
  import { vsLookupManagementServiceProviderName } from "../../../shared/lookups";

  export const vsObjectName = "machineDisplayType";

  const url = "/api/machines/MachineDisplayType";

  export const machineDisplayTypeLookupConfig = simpleLookupConfig(
    vsLookupManagementServiceProviderName,
    {
      name: vsObjectName,
      nameSingular: "Display Type",
      url,
    }
  );
